module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-slider-up-wrap"
  }, [_c('ul', {
    staticClass: "slider-box"
  }, _vm._l((_vm.dataset), function(str) {
    return _c('li', {
      staticClass: "slider-item"
    }, [_vm._v(_vm._s(str))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a0c5b48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/text-slider/index.vue
// module id = 241
// module chunks = 0